import React from "react"
import { CardElement } from "@stripe/react-stripe-js"
import ReactDatetime from "react-datetime"
import randomstring from "randomstring"
import NotificationAlert from "react-notification-alert"
import {
  Badge,
  Button,
  Container,
  Card,
  CardBody,
  CardTitle,
  ButtonDropdown,
  Row,
  Col,
  Input,
  Form,
  FormGroup,
  InputGroupAddon,
  DropdownMenu,
  DropdownToggle,
  InputGroupText,
  InputGroup,
} from "reactstrap"

import {
  getStateFromZipCode,
  getLocalISODateString,
  isValidJSObject,
  isValidEmailAddress,
  isValidJSDate,
  isValidPhoneNumber,
} from "actions/localActions"
import { ErrorBoundary } from "components/Common"
import Config from "config"
import { Constants } from "scripts"
import {
  CheckoutFormAndModalComponent,
  OrderSummary,
} from "./components/ScheduleOrder"
import firebase from "firebase/app"
import useCustomerData from "components/CustomerSettings/useCustomerData"
import UserAddress from "components/CustomerSettings/AddressSettings/UserAddress"
const START_TIME = "09:00"
const CLOSING_TIME = "18:00"
const SLOTS_TO_BE_BOOKED_CONCESSION = 1

console.log(Config)

let currentUser = {}
function startDataListeners() {
  /**
   * Get all payment methods for the logged in customer
   */
  firebase
    .firestore()
    .collection("stripe_customers")
    .doc(currentUser.uid)
    .collection("payment_methods")
    .onSnapshot((snapshot) => {
      if (snapshot.empty) {
        // document.querySelector("#add-new-card").open = true
      }
      snapshot.forEach(function (doc) {
        const paymentMethod = doc.data()
        if (!paymentMethod.card) {
          return
        }

        // const optionId = `card-${doc.id}`;
        // let optionElement = document.getElementById(optionId);

        // Add a new option if one doesn't exist yet.
        // if (!optionElement) {
        //   optionElement = document.createElement('option');
        //   optionElement.id = optionId;
        //   document
        //     .querySelector('select[name=payment-method]')
        //     .appendChild(optionElement);
        // }

        // optionElement.value = paymentMethod.id;
        // optionElement.text = `${paymentMethod.card.brand} •••• ${paymentMethod.card.last4} | Expires ${paymentMethod.card.exp_month}/${paymentMethod.card.exp_year}`;
      })
    })

  /**
   * Get all payments for the logged in customer
   */
  firebase
    .firestore()
    .collection("stripe_customers")
    .doc(currentUser.uid)
    .collection("payments")
    .onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        const payment = doc.data()

        // let liElement = document.getElementById(`payment-${doc.id}`);
        // if (!liElement) {
        //   liElement = document.createElement('li');
        //   liElement.id = `payment-${doc.id}`;
        // }

        // let content = '';
        if (
          payment.status === "new" ||
          payment.status === "requires_confirmation"
        ) {
          // content = `Creating Payment for ${formatAmount(
          //   payment.amount,
          //   payment.currency
          // )}`;
        } else if (payment.status === "succeeded") {
          // const card = payment.charges.data[0].payment_method_details.card;
          // content = `✅ Payment for ${formatAmount(
          //   payment.amount,
          //   payment.currency
          // )} on ${card.brand} card •••• ${card.last4}.`;
        } else if (payment.status === "requires_action") {
          // content = `🚨 Payment for ${formatAmount(
          //   payment.amount,
          //   payment.currency
          // )} ${payment.status}`;
          // handleCardAction(payment, doc.id);
        } else {
          // content = `⚠️ Payment for ${formatAmount(
          //   payment.amount,
          //   payment.currency
          // )} ${payment.status}`;
        }
        // liElement.innerText = content;
        // document.querySelector('#payments-list').appendChild(liElement);
      })
    })
}

class ScheduleOrder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disableConfirm: false,
      zipCode: "",
      disableZipCode: false,
      zipCodeArr: [],
      zipCodeDropdown: false,
      showModal: false,
      validation: {},
      slotPlaceholder: `Select Time Slot`,
      firstName: "",
      lastName: "",
      phone: "",
      emailAddress: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      paymentError: null,
      orderSlots: [],
      selectedOrderSlot: null,
      currOrderSlots: [],
      promoCodeInfo: {},
      promoCode: "",
      discountCost: 0,
      checkoutMethodTitle: null,
      // NEW CODE ADDED
      customerData: {},
    }
    this._toggleModal = this._toggleModal.bind(this)
    this._setPromoCode = this._setPromoCode.bind(this)
    this._setPromoCodeInfo = this._setPromoCodeInfo.bind(this)
    this._setDiscountCost = this._setDiscountCost.bind(this)
    this._fetchClientSecret = this._fetchClientSecret.bind(this)
    this._setPaymentRequest = this._setPaymentRequest.bind(this)
    this._placeOrder = this._placeOrder.bind(this)
    this._setCheckoutMethodTitle = this._setCheckoutMethodTitle.bind(this)
    this._handlePaymentChange = this._handlePaymentChange.bind(this)
    this._handlePaymentSubmit = this._handlePaymentSubmit.bind(this)
    this._setStateReducer = this._setStateReducer.bind(this)
    this._handleOnChange = this._handleOnChange.bind(this)
  }

  authListener() {
    this.fireBaseListener = firebase
      .auth()
      .onAuthStateChanged((firebaseUser) => {
        if (firebaseUser) {
          currentUser = firebaseUser
          firebase
            .firestore()
            .collection("stripe_customers")
            .doc(currentUser.uid)
            .onSnapshot((snapshot) => {
              if (snapshot.data()) {
                this.setState({ customerData: snapshot.data() })
                startDataListeners()
                // document.getElementById("loader").style.display = "none"
                // document.getElementById("content").style.display = "block"
              } else {
                console.warn(
                  `No Stripe customer found in Firestore for user: ${currentUser.uid}`
                )
              }
            })
        } else {
          // document.getElementById("content").style.display = "none"
          // firebaseUI.start("#firebaseui-auth-container", firebaseUiConfig)
        }
      })
  }

  componentWillMount() {
    this.authListener = this.authListener.bind(this)
    this.authListener()
  }

  componentWillUnmount() {
    this.fireBaseListener && this.fireBaseListener()
    this.authListener = undefined
  }

  componentDidMount() {
    const { zipCode, merchant } = this.props
    if (zipCode) {
      this.setState({
        zipCode,
        disableZipCode: true,
        state: getStateFromZipCode(zipCode),
      })
    } else if (merchant && merchant.zipCode) {
      this.setState({
        zipCodeArr: merchant.zipCode || [], // For ZipCode Dropdown
        zipCodeDropdown: true,
      })
    }
    this._fetchClientSecret() // For Stripe Payment
    window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevProps.promoCodeInfo) !==
      JSON.stringify(this.props.promoCodeInfo)
    ) {
      this.setState({ promoCodeInfo: this.props.promoCodeInfo })
    } else if (
      // Came Across This Logic By Trial And Error
      prevState.promoCode &&
      this.state.promoCode &&
      prevState.promoCode === this.state.promoCode &&
      JSON.stringify(prevProps.promoCodeInfo) ===
        JSON.stringify(this.props.promoCodeInfo) &&
      Object.keys(prevState.promoCodeInfo).length === 0 &&
      Object.keys(this.state.promoCodeInfo).length === 0
    ) {
      this.setState({ promoCodeInfo: this.props.promoCodeInfo })
    }
  }

  _getOrderSlots(startTime, closingTime) {
    let slots = []
    if (startTime >= 0 && closingTime <= 23) {
      for (let i = startTime; i < closingTime; i += 0.5) {
        let start, end
        const format = (num) => ((num + "").length === 1 ? "0" + num : num)
        if (Number.isInteger(i)) {
          start = format(i) + ":00"
          end = format(i) + ":30"
        } else {
          const num = parseInt(i)
          start = format(num) + ":30"
          end = format(num + 1) + ":00"
        }
        slots.push({
          start,
          end,
          startFtd: this._getAMPMTime(start),
          endFtd: this._getAMPMTime(end),
          isBooked: false,
          orderId: [],
        })
      }
    }
    return slots
  }

  _getAMPMTime(time) {
    let newTime = ""
    if (time) {
      const timeArr = time.split(":")
      const hour = parseInt(timeArr[0]),
        min = timeArr[1]
      if (hour === 0) {
        newTime = `12:${min} AM`
      } else if (hour === 12) {
        newTime = time + " PM"
      } else if (1 <= hour && hour <= 11) {
        newTime = time + " AM"
      } else if (13 <= hour && hour <= 23) {
        newTime = `0${hour - 12}:${min} PM`
      }
    }
    return newTime
  }

  _setOrderSlots(date) {
    if (date) {
      const { merchant } = this.props
      const slotId = getLocalISODateString(date).split("T")[0]
      console.log(
        this.props.orderDuration,
        merchant.startTime,
        merchant.closingTime
      )
      if (merchant && slotId) {
        const { merchantSlots } = this.props
        let currOrderSlots = merchantSlots[slotId]
        if (!currOrderSlots) {
          let { startTime, closingTime } = merchant
          startTime = startTime || START_TIME
          closingTime = closingTime || CLOSING_TIME
          const startHour = this._getStartOrClosingHour(startTime)
          const closingHour = this._getStartOrClosingHour(closingTime)
          currOrderSlots = this._getOrderSlots(startHour, closingHour)
        } else {
          currOrderSlots = this._orderSlotsToArray(currOrderSlots)
        }
        currOrderSlots = this._filterOrderSlots(currOrderSlots)
        this.setState({
          currOrderSlots,
        })
      }
    }
  }

  _filterOrderSlots(slots) {
    console.log("_filterOrderSlots")
    let { orderDuration } = this.props
    orderDuration = parseInt(orderDuration)
    if (slots && slots.length > 0 && orderDuration) {
      let slotsCopy = [...slots]
      let slotsToBeBooked = Math.ceil(parseInt(orderDuration) / 30)
      slotsToBeBooked = slotsToBeBooked - SLOTS_TO_BE_BOOKED_CONCESSION
      const terminalIndex = slotsCopy.length - slotsToBeBooked
      slots.forEach((item, idx) => {
        if (!item.isBooked && idx <= terminalIndex) {
          let currIdx = idx
          let nextIdx = currIdx + 1
          for (let i = 1; i < slotsToBeBooked; i++) {
            const currItem = slotsCopy[currIdx]
            const nextItem = slotsCopy[nextIdx]
            if (!currItem.isBooked && nextItem.isBooked) {
              let newSlot = { ...slotsCopy[idx] }
              newSlot.isRedundant = true
              slotsCopy[idx] = newSlot
            }
            currIdx++
            nextIdx++
          }
        }
      })
      return slotsCopy
    }
    return []
  }

  _getStartOrClosingHour(time) {
    if (time && typeof time === "string" && time.length === 5) {
      const timeArr = time.split(":")
      let hour = parseInt(timeArr[0])
      let min = parseInt(timeArr[1])
      if (min > 0 && min <= 30) {
        min = 30
      } else if (min > 30) {
        min = 0
        hour = hour + 1
      }
      hour = hour + min / 60
      return hour
    }
    return null
  }

  _fetchClientSecret(discountCost = 0) {
    const { selectedItems } = this.props
    console.log("discountCost", discountCost)
    if (selectedItems && selectedItems.vehicleType && selectedItems.package) {
      console.log("Client Secret - Fetching")
      window
        .fetch(`${Config.FirebaseFunctionUrl + "/app/createPaymentIntent"}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: selectedItems, discountCost }),
        })
        .then((res) => {
          console.log("Client Secret - Fetched")
          return res.json()
        })
        .then((data) => {
          console.log("Client Secret - Map2Props")
          this.setState({
            clientSecret: data.clientSecret,
          })
        })
        .catch((err) => {
          console.log(`Client Secret Not Fetched. Error:\n${err}`)
        })
    }
  }

  _handlePaymentChange = async (event) => {
    this.setState({
      paymentError: event.error ? event.error.message : "",
    })
  }

  _handlePaymentSubmit = async (elements, stripe) => {
    this.setState({ paymentProcessing: true })

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return
    }

    if (Object.keys(this.state.customerData).length) {
      const result = await stripe.confirmCardSetup(
        this.state.customerData.setup_secret,
        {
          payment_method: {
            card: elements.getElement(CardElement),
            billing_details: {
              name: "Getnet",
            },
          },
        }
      )

      if (result.error) {
        console.log("PAYMENT SAVING ERROR", result.error)
        // Display result.error.message in your UI.
      } else {
        // The setup has succeeded. Display a success message and send
        // result.setupIntent.payment_method to your server to save the
        // card to a Customer
        await firebase
          .firestore()
          .collection("stripe_customers")
          .doc(currentUser.uid)
          .collection("payment_methods")
          .add({ id: result.setupIntent.payment_method })
      }
    }

    const payload = await stripe.confirmCardPayment(this.state.clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    })

    if (payload.error) {
      this.setState({
        paymentIntent: payload.paymentIntent,
        paymentError: `Payment failed ${payload.error.message}`,
        paymentProcessing: false,
      })
    } else {
      this.setState({
        paymentIntent: payload.paymentIntent,
        paymentError: "",
        paymentProcessing: false,
        paymentSucceeded: true,
      })
    }

    this._placeOrder(payload.paymentIntent, true)
  }

  _getTotalCost() {
    let totalCost = 0
    const selectedItems = this.props.selectedItems
    const { package: pkg, addon } = selectedItems
    if (pkg) {
      totalCost += parseInt(pkg.cost) || 0
    }
    if (addon && addon.length > 0) {
      addon.forEach((item) => (totalCost += parseInt(item.cost) || 0))
    }
    return totalCost.toString()
  }

  _handleOnChange(name, e) {
    let value = e.target.value
    let validation = this.state.validation
    const invalid = "invalid"
    const valid = "valid"
    let result = valid
    switch (name) {
      case "firstName":
      case "lastName":
      case "city":
        if (value.length < 3) result = invalid
        break
      case "phone":
        value = value.replace(/[\s-)(]/g, "")
        value = value.slice(0, 10)
        if (!value) {
          value = ""
        } else if (value.length <= 3) {
          value = `(${value.substring(0, value.length)}`
        } else if (value.length <= 6) {
          value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}`
        } else if (value.length >= 7) {
          value = `(${value.substring(0, 3)}) ${value.substring(
            3,
            6
          )}-${value.substring(6, value.length)}`
        }
        if (!isValidPhoneNumber(value.trim())) result = invalid
        break
      case "emailAddress":
        if (!isValidEmailAddress(value.trim())) result = invalid
        break
      case "addressLine1":
        if (value.trim().length < 5) result = invalid
        break
      case "zipCode":
        value = value.slice(0, 5)
        this.setState({
          state: getStateFromZipCode(value),
        })
        break
      default:
        break
    }
    if (
      ["firstName", "lastName", "phone", "emailAddress", "zipCode"].indexOf(
        name
      ) > -1
    )
      value = value.trim()
    validation[name] = result
    this.setState({
      validation,
      [name]: value,
    })
  }

  _getOrderId(orderDate, orderTime, zipCode) {
    if (orderDate && orderTime && zipCode) {
      const formatMonth = (month) =>
        (month + "").length === 1 ? "0" + month : month
      const formatDate = (date) =>
        (date + "").length === 1 ? "0" + date : date
      const date =
        orderDate.getFullYear().toString() +
        formatMonth(orderDate.getMonth() + 1).toString() +
        formatDate(orderDate.getDate()).toString()

      const time = orderTime.replace(/[\s+:]/g, "")

      const unique = randomstring.generate({
        length: 8,
        readable: true,
        capitalization: "uppercase",
      })

      const orderId = date + "-" + time + "-" + zipCode + "-" + unique
      return orderId
    }
    return ""
  }

  _getOrderData() {
    const { selectedItems, orderDuration, merchant } = this.props
    if (selectedItems && orderDuration && merchant) {
      const {
        firstName,
        lastName,
        phone,
        emailAddress,
        addressLine1,
        addressLine2,
        city,
        zipCode,
        state,
        discountCost,
        promoCode,
        orderTime,
        orderDate,
        orderDateOffset,
        paymentIntent,
        paymentSucceeded,
      } = this.state
      const totalCost = this._getTotalCost()
      const orderId = this._getOrderId(orderDate, orderTime, zipCode)
      return {
        addressLine1,
        addressLine2: addressLine2 || "",
        city,
        email: emailAddress,
        firstName,
        lastName,
        phone,
        state,
        zipCode,

        merchantEmail: merchant.email,
        merchantId: merchant.merchantId,
        merchantName: merchant.name,
        merchantPhone: merchant.phone,
        merchantZipCode: merchant.zipCode,
        merchantLogo: merchant.logo || "",

        orderDate,
        orderDateOffset,
        orderDuration,
        orderId,
        orderPlaced: true,
        orderTime,

        addon: selectedItems.addon,
        discountCost,
        finalCost: parseInt(totalCost) - discountCost,
        promoCode,
        package: selectedItems.package,
        totalCost,
        vehicleType: this._getReducedVehicleType(selectedItems.vehicleType),

        paymentIntent,
        paymentSucceeded,
      }
    }
    return {}
  }

  _getReducedVehicleType(vehicleType) {
    if (vehicleType) {
      const vehicleTypeCopy = { ...vehicleType }
      delete vehicleTypeCopy.addon
      delete vehicleTypeCopy.packages
      delete vehicleTypeCopy.selectedAddons
      return vehicleTypeCopy
    }
    return {}
  }

  _isDataCollected() {
    const {
      firstName,
      lastName,
      phone,
      emailAddress,
      addressLine1,
      // addressLine2, // Not Compulsory
      city,
      zipCode,
      state,
      orderTime,
      orderDate,
      orderDateOffset,
      paymentError,
    } = this.state
    const totalCost = this._getTotalCost()
    // console.log(firstName, lastName, phone, emailAddress, 'addressLine1', addressLine1, 'city', city, zipCode, state, orderTime, orderDate, orderDateOffset, paymentError, totalCost);
    return !!(
      firstName &&
      emailAddress &&
      addressLine1 &&
      city &&
      zipCode &&
      state &&
      orderTime &&
      orderDate &&
      typeof orderDateOffset === "number" &&
      // && (paymentError !== null) && !paymentError
      !paymentError &&
      totalCost > 0
    )
    // ToDo: Add paymentProcessing --> false
  }

  notify = (type, message, title) => {
    const options = Constants.NotificationAlertOptions(type, message, title)
    this.refs.notificationAlert.notificationAlert(options)
  }

  _handleNextClick() {
    if (!this._isDataCollected()) {
      this.notify("danger", "Please Enter All The Details", "Warning")
      // ToDo: Form Validation
    } else if (!this.state.showModal) {
      this._toggleModal()
    }
  }

  _getSlotsToBeBooked() {
    // ToDo: Later
  }

  _getUpdatedMerchantOrderSlots(orderId) {
    let { currOrderSlots, selectedOrderSlot } = this.state
    let { orderDuration } = this.props
    if (
      currOrderSlots &&
      currOrderSlots.length > 0 &&
      selectedOrderSlot &&
      orderDuration &&
      orderId
    ) {
      let bookedIndices = []
      const startIndex = currOrderSlots.indexOf(selectedOrderSlot)
      const slotsToBeBooked = Math.ceil(parseInt(orderDuration) / 30)
      if (startIndex > -1 && slotsToBeBooked >= 1) {
        for (let i = 0; i < slotsToBeBooked; i++) {
          bookedIndices.push(startIndex + i)
        }
      }
      currOrderSlots = currOrderSlots.map((slot, idx) => {
        let slotCopy = { ...slot }
        if (bookedIndices.indexOf(idx) > -1) {
          slotCopy.isBooked = true
          if (slotCopy.orderId) {
            slotCopy.orderId = [...slotCopy.orderId, orderId]
          } else {
            slotCopy.orderId = [orderId]
          }
        }
        return slotCopy
      })
      return currOrderSlots
    }
    return null
  }

  _orderSlotsToObject(slots) {
    let slotObj = {}
    if (slots && Array.isArray(slots) && slots.length > 0) {
      slots.forEach((slot) => {
        const { start, end } = slot
        const newSlot = { ...slot }
        delete newSlot.isRedundant
        slotObj[`${start.trim()}-${end.trim()}`] = newSlot
      })
    }
    return slotObj
  }

  _orderSlotsToArray(slots) {
    let slotArr = []
    if (slots && Object.keys(slots).length > 0) {
      slotArr = Object.values(slots)
      slotArr = slotArr.sort((a, b) => {
        const aMinutes =
          parseInt(a.start.split(":")[0]) * 60 + parseInt(a.start.split(":")[1])
        const bMinutes =
          parseInt(b.start.split(":")[0]) * 60 + parseInt(b.start.split(":")[1])
        return aMinutes - bMinutes
      })
    }
    return slotArr
  }

  _placeOrder(paymentIntent, paymentSucceeded) {
    if (this._isDataCollected() && !this.state.paymentProcessing) {
      let orderData = this._getOrderData()
      let updatedOrderSlots = this._getUpdatedMerchantOrderSlots(
        orderData.orderId
      )
      let orderSlotsForOrderData = updatedOrderSlots.filter(
        (slot) => slot.orderId && slot.orderId.indexOf(orderData.orderId) > -1
      )
      orderSlotsForOrderData = orderSlotsForOrderData.map((slot) => {
        const newSlot = { ...slot }
        delete newSlot.orderId
        return newSlot
      })
      orderData = {
        ...orderData,
        orderSlots: orderSlotsForOrderData,
        paymentIntent,
        paymentSucceeded,
      }
      this.props
        .addOrder(orderData)
        .then((isOrderPlaced) => {
          if (isOrderPlaced) {
            // this.notify('success', 'Order Successfully Placed!', 'Success');
            this.setState({
              disableConfirm: true,
            })
            const { merchant } = this.props
            if (merchant && merchant.id) {
              if (updatedOrderSlots) {
                updatedOrderSlots = this._orderSlotsToObject(updatedOrderSlots)
                const updatedOrderSlotsId = getLocalISODateString(
                  this.state.orderDate
                ).split("T")[0]
                // const docId = `${this.props.merchantId}-${getLocalISODateString().split('T')[0].split('-').slice(0, 2).join('-')}`
                const data = {
                  docId: this.props.merchantId,
                  updatedOrderSlotsId,
                  updatedOrderSlots,
                }
                this.props.setMergeMerchantOrderSlots(data)
              }
              this.props.incrementTotalOrders(merchant.id)
            }
            const { promoCode, discountCost } = this.state
            if (promoCode && discountCost > 0) {
              this.props.incrementPromoCodeUsageCount({ promoCode })
            }
          } else {
            // this.notify('danger', 'Error Processing Order!', 'Warning');
            this.setState({
              disableConfirm: true,
            })
          }
        })
        .then(() => {
          this.props.history.push({
            pathname: "/thankYou",
            state: {
              orderData: this._getOrderData(),
            },
          })
        })
    }
  }

  _toggleModal() {
    this.setState({
      showModal: !this.state.showModal,
    })
  }

  _setPromoCode(promoCode) {
    if (typeof promoCode === "string")
      this.setState({ promoCode: promoCode.trim().toUpperCase() })
  }

  _setDiscountCost(discountCost) {
    if (typeof discountCost === "number" && discountCost >= 0)
      this.setState({ discountCost })
  }

  _setPromoCodeInfo(promoCodeInfo) {
    this.setState({ promoCodeInfo })
  }

  _setPaymentRequest(paymentRequest) {
    this.setState({ paymentRequest })
  }

  _setCheckoutMethodTitle(checkoutMethodTitle) {
    if (checkoutMethodTitle) {
      this.setState({
        checkoutMethodTitle,
      })
    }
  }

  _setStateReducer(name, value) {
    if (name) {
      const setLocalState = (n, v) => this.setState({ [n]: v })
      switch (name) {
        case "orderSlots":
          if (value && isValidJSDate(value)) {
            this._setOrderSlots(value)
          }
          break
        case "orderDate":
          if (value && isValidJSDate(value)) {
            setLocalState(name, value)
          }
          break
        case "orderDateOffset":
          if (typeof value === "number") {
            setLocalState(name, value)
          }
          break
        case "btnDropleft":
          if (typeof value === "boolean") {
            setLocalState(name, value)
          }
          break
        case "selectedOrderSlot":
          setLocalState(name, value) // value Can Be null, JSON
          break
        case "orderTime": // orderTime Is A String
        case "slotPlaceholder":
          if (typeof value === "string") {
            setLocalState(name, value)
          }
          break
        case "paymentError":
          if (value === null || typeof value === "string") {
            setLocalState(name, value)
          }
          break
        default:
          break
      }
    }
  }

  render() {
    const totalCost = this._getTotalCost()
    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <div className="header pt-5 pb-7">
          <Container className="chift-container-lg">
            <div className="header-body">
              <Row className="align-items-center">
                <Col lg="6">
                  <ErrorBoundary>
                    <OrderSummary
                      merchant={this.props.merchant}
                      selectedItems={this.props.selectedItems}
                      totalCost={totalCost}
                      promoCode={this.state.promoCode}
                      setPromoCode={this._setPromoCode}
                      setPromoCodeInfo={this._setPromoCodeInfo}
                      setDiscountCost={this._setDiscountCost}
                      fetchPromoCode={this.props.fetchPromoCode}
                      promoCodeInfo={this.state.promoCodeInfo}
                      fetchClientSecret={this._fetchClientSecret}
                    />
                  </ErrorBoundary>
                </Col>
                <Col lg="6">
                  <ErrorBoundary>
                    <OrderDateAndTime
                      setStateReducer={this._setStateReducer}
                      stateProps={{
                        btnDropleft: this.state.btnDropleft,
                        orderDate: this.state.orderDate,
                        slotPlaceholder: this.state.slotPlaceholder,
                        currOrderSlots: this.state.currOrderSlots,
                        selectedOrderSlot: this.state.selectedOrderSlot,
                      }}
                    />
                  </ErrorBoundary>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col lg="12">
                  <ErrorBoundary>
                    <OrderDetails
                      stateProps={{
                        firstName: this.state.firstName,
                        lastName: this.state.lastName,
                        phone: this.state.phone,
                        emailAddress: this.state.emailAddress,
                        addressLine1: this.state.addressLine1,
                        addressLine2: this.state.addressLine2,
                        city: this.state.city,
                        state: this.state.state,
                        zipCode: this.state.zipCode,
                        zipCodeDropdown: this.state.zipCodeDropdown,
                        zipCodeArr: this.state.zipCodeArr,
                        disableZipCode: this.state.disableZipCode,
                      }}
                      handleOnChange={this._handleOnChange}
                      validation={this.state.validation}
                      notify={this.notify}
                      updateState={(obj) =>
                        this.setState({ ...this.state, ...obj })
                      }
                    >
                      <CheckoutFormAndModalComponent
                        stateProps={{
                          ...this.state,
                          orderData: this._getOrderData(),
                        }}
                        callbacks={{
                          setCheckoutMethodTitle: this._setCheckoutMethodTitle,
                          setPaymentRequest: this._setPaymentRequest,
                          placeOrder: this._placeOrder,
                          toggleModal: this._toggleModal,
                          handlePaymentChange: this._handlePaymentChange,
                          handlePaymentSubmit: this._handlePaymentSubmit,
                          setStateReducer: this._setStateReducer,
                        }}
                      />
                    </OrderDetails>
                  </ErrorBoundary>
                </Col>
              </Row>
              <Row>
                <Col lg="12" className="text-center">
                  <Button
                    disabled={this.state.disableConfirm}
                    color="primary"
                    onClick={() => this._handleNextClick()}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </>
    )
  }
}

const OrderDateAndTime = ({ setStateReducer, stateProps }) => {
  const areOrderSlotsAvailable = (slots = []) => {
    if (slots && slots.length > 0) {
      const filteredBookedAndRedundantSlots = slots
        .map((v) => !v.isBooked && !v.isRedundant)
        .filter((v) => v)
      return filteredBookedAndRedundantSlots.length > 0
    }
    return false
  }
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-3 text-primary" tag="h3">
          Select Date
        </CardTitle>
        <FormGroup>
          <InputGroup className="input-group-alternative">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="ni ni-calendar-grid-58" />
              </InputGroupText>
            </InputGroupAddon>
            <ReactDatetime
              inputProps={{ placeholder: "Select Date" }}
              timeFormat={false}
              dateFormat={"MMMM Do YYYY"}
              isValidDate={(currentDate) => {
                const today = ReactDatetime.moment()
                const day = "day"
                const later = today.clone().add(30, day) // Allowing A Selection Range Of 30 Days For Order Booking
                return (
                  currentDate.isSame(today, day) ||
                  (currentDate.isAfter(today, day) &&
                    currentDate.isBefore(later, day))
                )
              }}
              onChange={(moment) => {
                if (moment && moment._isAMomentObject) {
                  setStateReducer("orderSlots", moment.toDate())
                  setStateReducer("orderDate", moment.toDate())
                  setStateReducer(
                    "orderDateOffset",
                    moment.toDate().getTimezoneOffset()
                  )
                  setStateReducer("btnDropleft", true)
                  setStateReducer("selectedOrderSlot", null)
                  setStateReducer("slotPlaceholder", "Select Time Slot")
                }
              }}
              closeOnSelect={true}
            />
          </InputGroup>
        </FormGroup>
        <CardTitle className="mb-3 text-primary" tag="h3">
          Select Time
        </CardTitle>
        <FormGroup>
          <InputGroup className="input-group-alternative">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="ni ni-time-alarm" />
              </InputGroupText>
            </InputGroupAddon>
            <ButtonDropdown
              isOpen={stateProps.btnDropleft}
              toggle={() => {
                setStateReducer("btnDropleft", !stateProps.btnDropleft)
              }}
            >
              <DropdownToggle
                color=""
                size="md"
                className="text-light"
                disabled={!stateProps.orderDate}
              >
                {stateProps.slotPlaceholder}
              </DropdownToggle>
              <DropdownMenu
                className="dropdown-menu-arrow"
                style={{ minWidth: "350px", padding: "20px" }}
              >
                {areOrderSlotsAvailable(stateProps.currOrderSlots)
                  ? stateProps.currOrderSlots.map((slot, idx) => {
                      const { selectedOrderSlot } = stateProps
                      const slotId = `orderSlot-${idx}`
                      const color =
                        selectedOrderSlot &&
                        selectedOrderSlot.start === slot.start
                          ? "primary"
                          : "secondary"
                      if (!slot.isBooked && !slot.isRedundant) {
                        return (
                          <Badge
                            className="time-badge"
                            key={slotId}
                            color={color}
                            pill
                            style={{
                              cursor: "pointer",
                              fontSize: "0.9rem",
                            }}
                            onClick={() => {
                              setStateReducer("selectedOrderSlot", slot)
                              setStateReducer("slotPlaceholder", slot.startFtd)
                              setStateReducer("orderTime", slot.startFtd)
                              setStateReducer("btnDropleft", false)
                            }}
                          >
                            {`${slot.startFtd}`}
                          </Badge>
                        )
                      }
                      return null
                    })
                  : "Please Select Another Date"}
              </DropdownMenu>
            </ButtonDropdown>
          </InputGroup>
        </FormGroup>
      </CardBody>
    </Card>
  )
}

const InputSection = ({
  label,
  autoComplete = false,
  id,
  onChange,
  name,
  placeholder = "Input Section",
  type = "text",
  validation,
  value,
  validFeedback = "Looks Good!",
  invalidFeedback = "Please Enter Correct Details",
  disabled = false,
}) => {
  let attr = {
    autoComplete: autoComplete ? "on" : "off",
    id: id,
    onChange: (e) => onChange(name, e),
    placeholder: placeholder,
    type: type,
    value: value,
  }
  if (isValidJSObject(validation)) {
    attr.valid = validation[name] === "valid"
    attr.invalid = validation[name] === "invalid"
  }
  if (typeof disabled === "boolean" && disabled) {
    attr.disabled = true
  }
  return (
    <FormGroup>
      <label className="form-control-label" htmlFor={id}>
        {label}
      </label>
      <Input {...attr} />
      {isValidJSObject(validation) ? (
        <>
          <div className="valid-feedback">{validFeedback}</div>
          <div className="invalid-feedback">{invalidFeedback}</div>
        </>
      ) : null}
    </FormGroup>
  )
}

const OrderDetails = ({
  stateProps,
  handleOnChange,
  validation,
  children,
  notify,
  updateState,
}) => {
  const { auth, addressList } = useCustomerData()
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-3 text-center text-primary" tag="h2">
          Order Details
        </CardTitle>
        <CardBody>
          {addressList?.length ? (
            <UserAddress
              addressList={addressList}
              auth={auth}
              notify={notify}
              onRadioChange={({
                addressLine1 = "",
                addressLine2 = "",
                city = "",
                state = "",
                name = "",
              } = {}) => {
                const [firstName = "", lastName = ""] = name.split(" ") || []
                updateState({
                  addressLine1,
                  addressLine2,
                  city,
                  state,
                  firstName,
                  lastName,
                  emailAddress: auth.email,
                })
              }}
            />
          ) : (
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <InputSection
                    id="first-name"
                    label="First Name"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="firstName"
                    placeholder="Mark"
                    validation={validation}
                    value={stateProps.firstName}
                    invalidFeedback="First Name Should Be At Least 3 Characters."
                  />
                </Col>
                <Col md="6">
                  <InputSection
                    id="last-name"
                    label="Last Name"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="lastName"
                    placeholder="Otto"
                    validation={validation}
                    value={stateProps.lastName}
                    invalidFeedback="Last Name Should Be At Least 3 Characters."
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <InputSection
                    id="phone-number"
                    label="Phone"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="phone"
                    placeholder="(987) 654-3210"
                    type="tel"
                    validation={validation}
                    value={stateProps.phone}
                    invalidFeedback="Invalid Phone Number"
                  />
                </Col>
                <Col md="6">
                  <InputSection
                    id="email-address"
                    label="Email Address"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="emailAddress"
                    placeholder="john@doe.com"
                    type="email"
                    validation={validation}
                    value={stateProps.emailAddress}
                    invalidFeedback="Invalid Email Address"
                  />
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <InputSection
                    id="address-line-1"
                    label="Address Line 1"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="addressLine1"
                    placeholder="Line 1"
                    validation={validation}
                    value={stateProps.addressLine1}
                    invalidFeedback="Address Should Be At Least 5 Characters"
                  />
                </Col>
                <Col md="6">
                  <InputSection
                    id="address-line-2"
                    label="Address Line 2"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="addressLine2"
                    placeholder="Line 2 (Optional)"
                    value={stateProps.addressLine2}
                    // Validation Is Not Necessary, Since This Is Optional
                  />
                </Col>
              </Row>
              <Row className="mb-n2">
                <Col md="4">
                  <InputSection
                    id="city-name"
                    label="City"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="city"
                    placeholder="City"
                    validation={validation}
                    value={stateProps.city}
                    invalidFeedback="City Should Be At Least 3 Characters"
                  />
                </Col>
                <Col md="4">
                  <InputSection
                    id="state-name"
                    label="State"
                    autoComplete={false}
                    onChange={handleOnChange}
                    name="state"
                    placeholder="State"
                    value={stateProps.state}
                    disabled={true}
                  />
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="zipCode">
                      Zip Code
                    </label>
                    {stateProps.zipCodeDropdown &&
                    stateProps.zipCodeArr &&
                    stateProps.zipCodeArr.length > 0 ? (
                      <Input
                        id="zipCode"
                        defaultValue="Zip Code"
                        onChange={(e) => handleOnChange("zipCode", e)}
                        type="select"
                      >
                        <option disabled>{"Zip Code"}</option>
                        {stateProps.zipCodeArr.map((item, key) => (
                          <option key={key}>{item}</option>
                        ))}
                      </Input>
                    ) : (
                      <Input
                        autoComplete="off"
                        id="zipCode"
                        onChange={(e) => handleOnChange("zipCode", e)}
                        placeholder="Zip Code"
                        type="text"
                        value={stateProps.zipCode}
                        disabled={stateProps.disableZipCode}
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          )}
          <hr />
          <CardTitle className="mb-3 text-center text-primary" tag="h2">
            Select Payment Method
          </CardTitle>
          <br />
          <Row>
            <Col md="12">{children}</Col>
          </Row>
        </CardBody>
      </CardBody>
    </Card>
  )
}

export default ScheduleOrder
